<template>
  <section>
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      @selection-change="handleChoose"
      class="custom-tbl"
    >
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" width="80" label="序号"> </el-table-column>
      <el-table-column prop="MatchId" label="比赛Id"></el-table-column>
      <el-table-column prop="SessionInfo" label="场次信息"></el-table-column>
      <el-table-column prop="RegisterPrice" label="报名费"></el-table-column>
      <el-table-column prop="StartTime" label="开始时间"></el-table-column>
      <el-table-column prop="EndTime" label="结束时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button type="danger" size="mini" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
    <!-- 新增 -->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="对应比赛" prop="MatchId">
          <el-select v-model="addForm.MatchId">
            <el-option
              v-for="item in matchList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场次信息" prop="SessionInfo">
          <el-input
            v-model="addForm.SessionInfo"
            placeholder="请输入场次信息"
          ></el-input>
        </el-form-item>
        <el-form-item label="报名费" prop="RegisterPrice">
          <el-input-number v-model="addForm.RegisterPrice"></el-input-number>
        </el-form-item>
        <el-form-item label="开始时间" prop="StartTime">
          <el-date-picker
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间"
            v-model="addForm.StartTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="EndTime">
          <el-date-picker
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
            v-model="addForm.EndTime"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      title="新增"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="对应比赛" prop="MatchId">
          <el-select v-model="editForm.MatchId">
            <el-option
              v-for="item in matchList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场次信息" prop="SessionInfo">
          <el-input
            v-model="editForm.SessionInfo"
            placeholder="请输入场次信息"
          ></el-input>
        </el-form-item>
        <el-form-item label="报名费" prop="RegisterPrice">
          <el-input-number v-model="editForm.RegisterPrice"></el-input-number>
        </el-form-item>
        <el-form-item label="开始时间" prop="StartTime">
          <el-date-picker
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间"
            v-model="editForm.StartTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="EndTime">
          <el-date-picker
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
            v-model="editForm.EndTime"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  matchListAll,
  matchSessionList,
  addMatchSession,
  updateMatchSession,
  deleteMatchSession,
  batchDeleteMatchSession,
} from "@/api/match/match";
export default {
  components: { Toolbar },
  data() {
    return {
      filters: {},
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {},
      //新增界面数据
      addForm: {},
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {},
      //编辑界面数据
      editForm: {},
      matchList: [],
      idList: [],
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
    this.getMatch();
  },
  methods: {
    handleBatchDelete(){
        this.$confirm("确认删除吗?", "提示", {
          type: "warning",
        }).then(() => {
           batchDeleteMatchSession({ids:this.idList}).then(res=>{
               if(res.data.success){
                   this.initPage();
                   this.$message({
                       message: "删除成功",
                       type: "success",
                   });
                   this.getList();
               }
           })     
        })
    },
    handleChoose(e) {
      this.idList = e.map((item) => item.Id);
    },
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          let para = Object.assign({}, this.editForm);
          updateMatchSession(para).then((res) => {
            this.editLoading = false;
            if (res.data.success) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.initPage();
              this.getList();
            }
          });
        }
      });
    },
   
    handleEdit(row) {
      this.editForm = Object.assign({}, row);
      this.editFormVisible = true;
    },
    handleDel(row) {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          return deleteMatchSession({
            id: row.Id,
          });
        })
        .then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          }
        });
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          let para = Object.assign({}, this.addForm);
          addMatchSession(para).then((res) => {
            this.addLoading = false;
            if (res.data.success) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs["addForm"].resetFields();
              this.addFormVisible = false;
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        name: "",
      };
    },
    getList() {
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
      };
      this.listLoading = true;
      matchSessionList(para)
        .then((res) => {
          this.total = res.data.response.dataCount;
          this.list = res.data.response.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    getMatch() {
      matchListAll().then((res) => {
        this.matchList = res.data.response;
      });
    },
  },
};
</script>
<style scoped>
</style>